import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { SiiaPermissionType } from 'app/shared/models/role-type';
import { AuthService } from 'app/shared/services/auth.service';
import { ScreenService } from 'app/shared/services/screen.service';
import { TabItemLike } from '../../../tabs/tabs.component';

@Component({
  selector: 'app-occurrences-management',
  templateUrl: 'occurrences-management.component.html',
  styleUrls: ['occurrences-management.component.scss'],
})
export class OccurrencesManagementComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input()
  mapView: __esri.MapView;
  @Input()
  mainMapImageLayer: __esri.MapImageLayer;
  @Input()
  groupLayer: __esri.GroupLayer;

  occurrenceRegisterGroupLayer: __esri.GroupLayer;
  occurrenceSearchGroupLayer: __esri.GroupLayer;

  tabs: TabItemLike[] = [
    {
      text: 'CRIAR',
    },
    {
      text: 'PESQUISAR',
    },
  ];
  tabIndex = 0;

  private mapViewSubscription: Subscription;

  isMobileModeObservable = this.screenService.observeIsMobile();

  private lifecycle = new Subject<void>();

  constructor(
    private authService: AuthService,
    private screenService: ScreenService
  ) {}

  ngOnInit(): void {
    this.authService
      .observeHasSiiaPermission(SiiaPermissionType.CreateOccurrence)
      .pipe(takeUntil(this.lifecycle))
      .subscribe((canCreate) => {
        this.tabs[0].disabled = !canCreate;

        if (!canCreate) {
          this.tabIndex = 1;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mapView || changes.groupLayer) {
      this.handleMapView();
    }
  }

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();

    this.mapViewSubscription?.unsubscribe();
  }

  private handleMapView() {
    this.mapViewSubscription?.unsubscribe();
    if (!this.mapView) {
      return;
    }

    const layersMixin: __esri.LayersMixin = this.groupLayer ?? this.mapView.map;
    this.occurrenceRegisterGroupLayer = new GroupLayer();
    layersMixin.add(this.occurrenceRegisterGroupLayer);

    this.occurrenceSearchGroupLayer = new GroupLayer();
    layersMixin.add(this.occurrenceSearchGroupLayer);

    this.mapViewSubscription = new Subscription(() => {
      layersMixin.remove(this.occurrenceRegisterGroupLayer);
      this.occurrenceRegisterGroupLayer?.destroy();

      layersMixin.remove(this.occurrenceSearchGroupLayer);
      this.occurrenceSearchGroupLayer?.destroy();
    });
  }
}
